import { render, staticRenderFns } from "./onboardForm.vue?vue&type=template&id=55dc91dc&scoped=true"
import script from "./onboardForm.vue?vue&type=script&lang=js"
export * from "./onboardForm.vue?vue&type=script&lang=js"
import style0 from "./onboardForm.vue?vue&type=style&index=0&id=55dc91dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc91dc",
  null
  
)

export default component.exports